import { render, staticRenderFns } from "./user-chatbot.html?vue&type=template&id=712c4749&scoped=true&"
import script from "./user-chatbot.js?vue&type=script&lang=js&"
export * from "./user-chatbot.js?vue&type=script&lang=js&"
import style0 from "./user-chatbot.scss?vue&type=style&index=0&id=712c4749&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "712c4749",
  null
  
)

export default component.exports